import React from 'react';

import {
  ThreeDStockProductsListItemInfoProduct,
  ThreeDStockProductsListItemInfoProductsSet
} from './ThreeDStockProductsListItemInfo.types';
import {
  FetchProductsSetsCacheKeys,
  UpdateProductsSetCacheAction
} from '../../../../../../productsSets/productsSetsTypes';
import {
  ChangeProductsFiltersFunc,
  FetchProductsFilters
} from '../../../../../../products/productsTypes';

import { useProductSelectButton } from '../../../../../../products/components/buttons/ProductSelectButton/hooks/useProductSelectButton';

import { ThreeDStockProductsListItemInfoBrand } from './components/ThreeDStockProductsListItemInfoBrand';

import { NextLinkHelper } from '../../../../../../../helpers/links/NextLinkHelper';
import { Translate } from '../../../../../../../helpers/Translate';
import { CheckBoxField } from '../../../../../../../helpers/FormFields/CheckBoxField';

import { words } from '../../../../../../../locales/keys';

interface ThreeDStockProductsListItemInfoProps {
  product: ThreeDStockProductsListItemInfoProduct;
  productsSet: ThreeDStockProductsListItemInfoProductsSet | null;
  productPagePath: string;
  productsSetCacheKeys?: FetchProductsSetsCacheKeys;
  updateProductsSetCache: UpdateProductsSetCacheAction<ThreeDStockProductsListItemInfoProductsSet>;
  changeProductsFilters: ChangeProductsFiltersFunc;
  productsFilters: FetchProductsFilters;
}

function ThreeDStockProductsListItemInfo({
  product,
  productsSet,
  productPagePath,
  updateProductsSetCache,
  productsSetCacheKeys,
  changeProductsFilters,
  productsFilters
}: ThreeDStockProductsListItemInfoProps) {
  const { isSelected, handleToggleSelected } = useProductSelectButton({
    product,
    productsSet,
    updateProductsSetCache,
    productsSetCacheKeys
  });

  return (
    <div className="flex px-3 py-2 items-center">
      <div className="flex-1 min-w-0 text-sm flex flex-col items-start gap-0.5">
        <NextLinkHelper
          className="font-semibold truncate max-w-full"
          dataGa="products-product-goto-product-page-link"
          href={productPagePath}
        >
          <div className="absolute inset-0 z-1" />
          {product.name}
        </NextLinkHelper>

        <div className="flex gap-2 max-w-full">
          {product.nda && (
            <span className="bg-yellow-200 text-black px-1 text-xs rounded uppercase">
              <Translate id={words.nda} />
            </span>
          )}

          <ThreeDStockProductsListItemInfoBrand
            changeProductsFilters={changeProductsFilters}
            product={product}
            productsFilters={productsFilters}
          />
        </div>
      </div>

      <div className="p-2.5 -mr-1.5 rounded-full hover:bg-gray-400/25 z-1 cursor-pointer md:hidden md:group-hover:block has-[:checked]:block group-focus-within:inline transition-color duration-150 ease-out">
        <CheckBoxField
          id="southport-patio-egg"
          name="select-product"
          checked={isSelected}
          onChange={handleToggleSelected}
          checkBoxClassName="basic-checkbox border-gray-600 dark:border-gray-400 dark:bg-gray-900"
        />
      </div>
    </div>
  );
}

export default ThreeDStockProductsListItemInfo;
